import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FontLoaderService {
  loadCustomFont(fontUrl: string, fontFamily: string) {
    const fontFace = new FontFace(fontFamily, `url(${fontUrl})`);

    return new Observable<null>((observer) => {
      fontFace
        .load()
        .then((loadedFont) => {
          document.fonts.add(loadedFont);
          observer.next(null);
          observer.complete();
        })
        .catch((error) => {
          observer.error(error);
        });
    });
  }
}
